// All marginalia
import React from 'react';
import TimeAxes from './time-axes';
import StationAxis from './station-axis';
import BrushableAxis from './brushable-axis';

// Markers that help you assess extent of the data
const Axes = (props) => {
  const { svgProps, stations, yScale, xScale, margin, xScaleAxis } = props;
  const transform = `translate(0,${margin.top})`;

  const clipProps = {
    y: -margin.top,
    height: svgProps.height,
    width: svgProps.width
  };

  const heightOffset = svgProps.height - margin.bottom - margin.top;

  const brushSpace = 40;
  return (
      // space for the brush
      <svg {...svgProps} height={svgProps.height + brushSpace} >
        <g transform={transform}>
          <defs>
            <clipPath id="clip">
              <rect {...clipProps} />
            </clipPath>
          </defs>
          <g className="train" />
          <StationAxis
            stations={stations}
            yScale={yScale}
            margin={margin}
            rulerWidth={svgProps.width - margin.left - margin.right - margin.left} // todo: check true width
          />
          {/* Top and Bottom Axes */}
          <TimeAxes height={heightOffset}  xScale={xScale}></TimeAxes>
          {/* Navigation */}
          <BrushableAxis xScale={xScaleAxis} y={heightOffset + brushSpace} margin={margin} width={svgProps.width}/>
        </g>
      </svg>
      );
}

export default Axes;
